module.exports = __webpack_public_path__ + "img/SDG Wheel_Transparent_WEB.6a4a77f1.png";